<app-eg-header *ngIf="!isLoginPage && !isAccountSetupSuccessPage && !isAccountSetupPage && !isRiderLoginPage"></app-eg-header>
<div class="layout" [ngClass]="{'with-sidebar': !isLoginPage && !isApplicantDetailPage && !isAccountSetupSuccessPage && !isAccountSetupPage && !isRiderLoginPage && !isRiderDashboardPage && !isRiderUserProfilePage && !isRiderApplicationPage && !isRiderSettingsPage}">
  <app-eg-nav-bar *ngIf="!isLoginPage && !isApplicantDetailPage && !isAccountSetupSuccessPage && !isAccountSetupPage && !isRiderLoginPage && !isRiderDashboardPage && !isRiderUserProfilePage && !isRiderApplicationPage && !isRiderSettingsPage"></app-eg-nav-bar>
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <!-- <app-notifications>
  </app-notifications> -->
</div>
